<template>
  <div class="srm-carousel-box">
    <el-carousel ref="carousel" :height="bannerHeight + 'px'" trigger="click" :interval="5000" arrow="always" @change="setActiveItem">
      <el-carousel-item v-for="(item, index) in carouselList"  :key="index">
        <div class="carousel-box" :class="`carousel-item-${index + 1}`">
          <img v-lazy="item.img" alt="" class="item-img">
          <div class="content">
            <div class="title">{{item.title}}</div>
            <div class="description">{{ item.description }}</div>
          </div>
          <div class="click-button flex-box pointer" @click="toLink(item)">
            <span class="button-text">了解详情</span>
            <el-image :src="require('@/assets/images/link-to.png')" />
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="carousel-option">
      <div
        v-for="(item, k) in carouselList"
        :key="k"
        class="option-item"
        :class="{'is-active': k === activeInd}"
        @click="onOptionClick(item, k)"
      >
        <div class="option-label">{{ item.label }}</div>
        <div class="option-subs list">
          <span v-for="(sub, si) in item.subs" :key="si">{{ sub }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CarouselContainer',
  props: {
    bannerHeight: {
      require: true
    }
  },
  data() {
    return {
      activeInd: 0,
      carouselList: [
        {
          label: '化工材料行业',
          subs: ['涂料与油墨', '塑料与改性高分子', '电子化学品（半导体/面板材料）', '精细化工（表面活性剂、助剂、催化剂）', '工业胶粘剂与密封剂', '农化', '金属材料', '新能源材料与电池材料'],
          title: '化工材料 AI 研发一体化平台',
          description: 'AI 赋能配方、实验、工艺、成本全数据链管理，提升研发效率',
          url: '/ChemicalIndustry',
          img: require('@/assets/images/lbhg.png')
        },
        {
          label: '食品饮料行业',
          subs: ['休闲零食', '饮料（含功能饮料）', '乳制品', '调味品', '预制菜 / 方便食品', '保健食品 / 功能食品', '宠物食品'],
          title: '食品饮料行业 AI+PLM 解决方案',
          description: 'AI 驱动食品饮料配方、原料与合规全链路管理，让新品研发更快落地',
          url: '/FoodBeverage',
          img: require('@/assets/images/lbsp.png')
        },
        {
          label: '日化美妆行业',
          subs: ['护肤品', '彩妆', '洗护用品', '口腔护理', '香氛', '家居清洁'],
          title: '日化美妆行业 AI+PLM 解决方案',
          description: 'PLM+AI 双驱动，美妆配方、合规与功效全流程智能协同，助力新品研发高效落地',
          url: '/BeautyMakeup',
          img: require('@/assets/images/lbrh.png')
        },
        {
          label: '生命科学',
          subs: ['医疗器械', '制药', '医疗耗材', 'IVD试剂', '农药', '宠物药品'],
          title: '医疗器械行业PLM实施',
          description: '实现医疗行业的高效研发创新，缩短产品开发周期和研发成本',
          url: '/MedicalEquipment',
          img: require('@/assets/images/bg1.png')
        },
        {
          label: '离散行业',
          subs: ['芯片', '半导体', '3C电子'],
          title: '芯片半导体PLM解决方案',
          description: '帮助芯片半导体行业规范产品数据管理，实现研发全面信息化管理',
          url: '/Semiconductor',
          img: require('@/assets/images/bg2.png')
        },
        // {
        //   label: '机械制造',
        //   title: '工业制造PLM系统',
        //   description: '提升机械制造企业研发效率，帮助实现产品数据标准化、规范化，形成产品研发数据共享与传承',
        //   url: '/MachineryManufactur',
        //   img: require('@/assets/images/bg5.png')
        // }
      ]
    }
  },
  methods: {
    toLink(item) {
      this.$router.push(item.url)
    },
    setActiveItem(val) {
      this.activeInd = val
    },
    carouselClick(k) {
      this.$refs.carousel.setActiveItem(k)
    },
    onOptionClick(item, k) {
      if (window.innerWidth < 768) {
        this.carouselClick(k)
        return
      }
      this.toLink(item)
    }
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.srm-carousel-box {
  position: relative;
  .carousel-option {
    position: absolute;
    left: 0;
    right: 0;
    top: 38rem;
    bottom: 0;
    z-index: 9;
    display: flex;
    align-items: flex-start;
    gap: 2.4rem;
    width: 100%;
    padding: 1.2rem 1rem 9rem 20rem;
    box-sizing: border-box;
    background: transparent;
    .option-item {
      flex: 1 1 0;
      width: 0;
      min-width: 0;
      box-sizing: border-box;
      padding: 0.8rem 1rem 1.2rem;
      cursor: pointer;
    }
    .option-label {
      font-size: 2.2rem;
      line-height: 3.2rem;
      margin-bottom: 1.2rem;
      color: #3674FE;
      font-weight: bold;
      // 只保留贴边白底托，去掉 0.6rem 的白色光晕（会让蓝色笔画边缘发虚）
      text-shadow: 0 0.1rem 0.2rem rgba(255, 255, 255, 0.75);
      overflow-wrap: anywhere;
      word-break: break-word;
    }
    .option-item:hover .option-label {
      text-decoration: underline;
    }
    .option-item.is-active {
      border-radius: 0.8rem;
      background: rgba(255, 255, 255, 0.62);
    }
    .option-item.is-active .option-label {
      font-weight: 800;
      font-size: 2.8rem;
      line-height: 3.8rem;
    }
    .option-item.is-active .option-subs {
      font-size: 1.8rem;
      line-height: 2.6rem;
    }
    .option-subs {
      font-size: 1.6rem;
      line-height: 2.6rem;
      font-weight: 400;
      color: #333333;
      text-shadow: 0 0.1rem 0.2rem rgba(255, 255, 255, 0.75);
      &.list span {
        display: block;
      }
    }
  }
  ::v-deep .el-carousel--horizontal {
    .el-carousel__indicator--horizontal {
      padding: 1.2rem 1rem;
      display: none;
      .el-carousel__button {
        width: 3rem;
        height: 0.45rem;
        border-radius: 0.2rem;
      }
    }
    .el-carousel__arrow {
      width: 6rem;
      height: 6rem;
      font-size: 2.5rem;
      top: auto;
      bottom: 1.2rem;
      z-index: 10;
      color: #333333;
      background: #FFFFFF;
      opacity: .6;
      &:hover {
        opacity: 1;
      }
    }
    .el-carousel__arrow--left {
      left: calc(50% - 5rem);
      transform: translateX(-50%);
    }
    .el-carousel__arrow--right {
      right: auto;
      left: calc(50% + 5rem);
      transform: translateX(-50%);
    }
  }

  .carousel-box {
    height: 100%;
    min-height: 70rem;
    padding: 10rem 8rem 46rem 12rem;
    background-size: cover!important;
    background-repeat: no-repeat!important;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;

    .item-img {
      top: 0;
      left: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center center;
      z-index: 0;
    }

    .content,
    .click-button {
      position: relative;
      z-index: 1;
    }

    .content {
      .title {
        font-size: 4.8rem;
        line-height: 7rem;
        font-weight: 600;
        color: #2E3F5E;
        margin-bottom: 2.3rem;
      }

      .description {
        font-weight: 400;
        // width: 67.2rem;
        height: 8.4rem;
        font-size: 2.8rem;
        line-height: 4.2rem;
        color: #2E3F5E;
      }
    }

    .click-button {
      font-size: 2rem;
      line-height: 3rem;
      color: #FFF;
      background: linear-gradient(318deg, #0F81F4 0%, #37A4FF 100%);
      box-shadow: 0 0.7rem 2.5rem 0 rgba(15,129,244,0.2);
      border-radius: 2.7rem;
      padding: 1.2rem 2.3rem;
      border: 0.1rem solid #FFFFFF;
      align-items: center;
      margin-top: 3.2rem;

      .button-text {
        margin-right: 0.8rem;
      }

      .el-image {
        width: 3rem;
        height: 3rem;
      }
    }
  }

  .carousel-item-1 {
    .description {
      color: #666A77;
      width: 75.6rem;
    }
  }
  .carousel-item-2 {
    .description {
      color: #333;
      width: 67.2rem;
    }
  }
  .carousel-item-3 {
    .title {
      margin-bottom: 2.4rem!important;
    }
    .description {
      color: #333;
      width: 64.4rem;
    }
  }
  .carousel-item-4 {
    cursor: pointer;
    .description {
      color: #333;
      width: 70.4rem;
    }
  }
  .carousel-item-5 {
    cursor: pointer;
    .description {
      color: #333;
      width: 70rem;
    }
  }
  .carousel-item-6 {
    cursor: pointer;
    .description {
      color: #333;
      width: 70rem;
    }
  }

}

@import "@/styles/mixins.scss";

@include mobile {
  .srm-carousel-box {
    .carousel-option {
      display: flex;
      top: auto;
      gap: 1.2rem;
      width: 100%;
      max-width: none;
      padding: 1.2rem 1.2rem 6rem;
      overflow-x: auto;
      .option-item {
        flex: 1 0 14rem;
        text-align: left;
      }
      .option-label {
        font-size: 1.3rem;
        line-height: 1.8rem;
        margin-bottom: 0.4rem;
        padding: 0;
        background: transparent;
      }
      .option-item.is-active .option-label {
        font-size: 1.7rem;
        line-height: 2.2rem;
      }
      .option-item.is-active .option-subs {
        font-size: 1.3rem;
        line-height: 1.9rem;
      }
      .option-subs {
        font-size: 1.1rem;
        line-height: 1.6rem;
      }
    }

    ::v-deep .el-carousel--horizontal {
      .el-carousel__arrow {
        display: flex !important;
        align-items: center;
        justify-content: center;
        width: 3.6rem;
        height: 3.6rem;
        font-size: 1.4rem;
        top: auto !important;
        bottom: 0.8rem !important;
        z-index: 10;
      }
      .el-carousel__arrow--left {
        left: calc(50% - 4.4rem);
        right: auto;
        transform: translateX(-50%);
      }
      .el-carousel__arrow--right {
        right: auto;
        left: calc(50% + 4.4rem);
        transform: translateX(-50%);
      }
    }

    .carousel-box {
      min-height: 0;
      height: 100%;
      padding: 7.2rem 1.6rem 22rem;
      overflow: hidden;
      justify-content: flex-start;

      .item-img {
        object-fit: cover;
        object-position: center center;
      }

      .content {
        width: 100%;
        max-width: 100%;
        .title,
        .description {
          width: 100% !important;
          max-width: 100%;
          white-space: normal;
          word-break: break-word;
        }
        .title {
          font-size: 2.2rem;
          line-height: 3rem;
          margin-bottom: 1.2rem;
        }
        .description {
          height: auto;
          font-size: 1.4rem;
          line-height: 2.2rem;
        }
      }

      .click-button {
        font-size: 1.4rem;
        padding: 1rem 1.6rem;
        margin-top: 1.6rem;
      }
    }

    .carousel-item-1,
    .carousel-item-2,
    .carousel-item-3,
    .carousel-item-4,
    .carousel-item-5,
    .carousel-item-6 {
      .description {
        width: 100%;
      }
    }
  }
}
</style>
